import React, { useState, useEffect } from 'react';
import { getConsentState, setConsentState } from '../utils/consent';
import './CookieConsent.css';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [preferences, setPreferences] = useState({
    necessary: true,
    analytics: false,
    marketing: false
  });

  useEffect(() => {
    const stored = getConsentState();
    if (!stored || stored.decisionMade !== true) {
      setVisible(true);
    }
  }, []);

  useEffect(() => {
    const handler = () => {
      const stored = getConsentState();
      if (stored) {
        setPreferences({
          necessary: true,
          analytics: !!stored.analytics,
          marketing: !!stored.marketing
        });
      }
      setShowSettings(true);
      setVisible(true);
    };
    window.addEventListener('openCookieSettings', handler);
    return () => window.removeEventListener('openCookieSettings', handler);
  }, []);

  const handleAcceptAll = () => {
    setConsentState({ necessary: true, analytics: true, marketing: true });
    setVisible(false);
    setShowSettings(false);
  };

  const handleRejectAll = () => {
    setConsentState({ necessary: true, analytics: false, marketing: false });
    setVisible(false);
    setShowSettings(false);
  };

  const handleSavePreferences = () => {
    setConsentState(preferences);
    setVisible(false);
    setShowSettings(false);
  };

  if (!visible) return null;

  if (showSettings) {
    return (
      <div className="cookie-settings-modal" data-testid="cookie-settings-modal">
        <div className="cookie-settings-content">
          <h3>Cookie-Einstellungen</h3>
          <p className="cookie-settings-desc">
            Hier koennen Sie Ihre Cookie-Praeferenzen anpassen. Weitere Informationen finden Sie in unserer{' '}
            <a href="/datenschutz">Datenschutzerklaerung</a> und im <a href="/impressum">Impressum</a>.
          </p>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <h4>Notwendig</h4>
              <span className="cookie-always-active">Immer aktiv</span>
            </div>
            <p>Essenzielle Cookies fuer die Grundfunktionen der Website. Koennen nicht deaktiviert werden.</p>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <h4>Statistik / Analyse</h4>
              <label className="cookie-toggle" data-testid="cookie-toggle-analytics">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
                />
                <span className="cookie-toggle-slider"></span>
              </label>
            </div>
            <p>Helfen uns zu verstehen, wie Besucher mit der Website interagieren (z.B. PostHog).</p>
          </div>

          <div className="cookie-category">
            <div className="cookie-category-header">
              <h4>Marketing / Tracking</h4>
              <label className="cookie-toggle" data-testid="cookie-toggle-marketing">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                />
                <span className="cookie-toggle-slider"></span>
              </label>
            </div>
            <p>Werden fuer Google Ads und Meta Pixel Conversion-Tracking verwendet, um Werbung relevanter zu gestalten.</p>
          </div>

          <div className="cookie-settings-buttons">
            <button className="cookie-btn cookie-btn-reject" onClick={handleRejectAll} data-testid="cookie-settings-reject">Alle ablehnen</button>
            <button className="cookie-btn cookie-btn-save" onClick={handleSavePreferences} data-testid="cookie-settings-save">Auswahl speichern</button>
            <button className="cookie-btn cookie-btn-accept" onClick={handleAcceptAll} data-testid="cookie-settings-accept">Alle akzeptieren</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="cookie-consent-banner" data-testid="cookie-consent-banner">
      <div className="cookie-consent-inner">
        <div className="cookie-consent-text">
          <h3>Wir respektieren Ihre Privatsphaere</h3>
          <p>
            Wir verwenden Cookies und aehnliche Technologien, um Ihnen die bestmoegliche Erfahrung zu bieten.
            Weitere Details finden Sie in unserer <a href="/datenschutz">Datenschutzerklaerung</a> und im <a href="/impressum">Impressum</a>.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button className="cookie-btn cookie-btn-settings" onClick={() => setShowSettings(true)} data-testid="cookie-settings-btn">Einstellungen</button>
          <button className="cookie-btn cookie-btn-reject" onClick={handleRejectAll} data-testid="cookie-reject-btn">Nur notwendige</button>
          <button className="cookie-btn cookie-btn-accept" onClick={handleAcceptAll} data-testid="cookie-accept-btn">Alle akzeptieren</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
